import React, { useEffect, useState } from "react";
import api, { rupee } from "../../lib/api";
import { IndianRupee, ShoppingBag, Users, Contact2, TrendingUp, Clock } from "lucide-react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar, CartesianGrid } from "recharts";

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="text-muted-foreground">Loading dashboard...</div>;

  const cards = [
    { label: "Today's Orders", value: d.today_orders, icon: ShoppingBag },
    { label: "Today's Revenue", value: rupee(d.today_revenue), icon: IndianRupee },
    { label: "Monthly Revenue", value: rupee(d.monthly_revenue), icon: TrendingUp },
    { label: "Total Orders", value: d.total_orders, icon: ShoppingBag },
    { label: "Avg Order Value", value: rupee(d.average_order_value), icon: IndianRupee },
    { label: "Customers", value: d.new_customers, icon: Users },
    { label: "Returning", value: d.returning_customers ?? 0, icon: Users },
    { label: "Leads", value: d.leads, icon: Contact2 },
    { label: "Pending Orders", value: d.pending_orders, icon: Clock },
  ];
  const statusData = Object.entries(d.status_counts).map(([k, v]) => ({ name: k.replace(/_/g, " "), value: v }));

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-3xl text-navy mb-1">Dashboard</h1>
      <p className="text-sm text-muted-foreground mb-6">Overview of your royal kitchen operations</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {cards.map((c) => (
          <div key={c.label} className="bg-white rounded-xl border border-black/5 p-5" data-testid={`stat-${c.label.toLowerCase().replace(/[^a-z]/g, "-")}`}>
            <div className="flex justify-between items-start"><span className="text-xs text-muted-foreground uppercase tracking-wide">{c.label}</span><c.icon size={17} className="text-gold" /></div>
            <div className="font-serif text-2xl text-navy mt-2">{c.value}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-5 mb-6">
        <div className="bg-white rounded-xl border border-black/5 p-5">
          <h3 className="font-serif text-xl text-navy mb-4">Revenue (Last 7 Days)</h3>
          <ResponsiveContainer width="100%" height={240}>
            <LineChart data={d.revenue_series}><CartesianGrid strokeDasharray="3 3" stroke="#eee" /><XAxis dataKey="date" fontSize={11} /><YAxis fontSize={11} /><Tooltip formatter={(v) => rupee(v)} /><Line type="monotone" dataKey="revenue" stroke="#C5A059" strokeWidth={2.5} dot={{ r: 3 }} /></LineChart>
          </ResponsiveContainer>
        </div>
        <div className="bg-white rounded-xl border border-black/5 p-5">
          <h3 className="font-serif text-xl text-navy mb-4">Orders by Status</h3>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={statusData}><CartesianGrid strokeDasharray="3 3" stroke="#eee" /><XAxis dataKey="name" fontSize={10} interval={0} angle={-20} textAnchor="end" height={50} /><YAxis fontSize={11} allowDecimals={false} /><Tooltip /><Bar dataKey="value" fill="#0F172A" radius={[4, 4, 0, 0]} /></BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-black/5 p-5">
        <h3 className="font-serif text-xl text-navy mb-4">Best Sellers</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {d.best_sellers.map((b, i) => (
            <div key={i} className="flex justify-between items-center bg-beige rounded-lg px-4 py-3"><span className="text-sm text-navy">{b.name}</span><span className="text-sm font-semibold text-gold">{b.sold} sold</span></div>
          ))}
        </div>
      </div>
    </div>
  );
}
